import axios from 'axios';
export default {
  generatePDF: ({ id, language }) => axios.get(`/api/v1/reports/report/${id}/pdf/${language}`),
  getReportById: (id) => axios.get(`/api/v1/reports/report/${id}`),
};
